function handleExistingCustomer() {
  // Check if currently on login page
  if (window.location.href.includes('/account/login')) {
    
    // Check if there's an error in the login form
    const hasLoginError = document.querySelector('#CustomerLoginForm')?.querySelector('.form__error');
    
    // Check sessionStorage flag from register page
    const registrationAttempt = sessionStorage.getItem('registration_attempt');
    
    console.log('Current location:', window.location.href);
    console.log('Has login error:', !!hasLoginError);
    console.log('Registration attempt:', registrationAttempt);
    
    // If NO login error AND has flag from register
    if (!hasLoginError && registrationAttempt === 'true') {
      // Clear sessionStorage flag
      sessionStorage.removeItem('registration_attempt');
      
      // Redirect to confirmation page
      console.log('Redirecting to confirmation page...');
      window.location.href = '/pages/beach-club-confirmation';
    }
    
    // If HAS login error but still has flag from register
    else if (hasLoginError && registrationAttempt === 'true') {
      console.log('Login error detected but came from register - keeping flag');
      // Keep flag to handle after successful login
    }
    
    // If no flag from register
    else if (!registrationAttempt) {
      console.log('No registration attempt flag found');
    }
  }
}

// Call function when DOM loaded
document.addEventListener('DOMContentLoaded', handleExistingCustomer);

// Or call immediately
handleExistingCustomer();
